import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-sale-payment-cancel',
  templateUrl: './custom-sale-payment-cancel.component.html',
  styleUrls: ['./custom-sale-payment-cancel.component.scss']
})
export class CustomSalePaymentCancelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
